import PagedElements from '@/models/paged/pagedelements';
import StoreListViewModel from '@/models/view/storelistviewmodel';

export default class PagedStores extends PagedElements<StoreListViewModel> {
    constructor(init?: Partial<PagedStores>) {
        super(init);
    }
}
